"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryParamsBuilder = void 0;
const query_string_1 = require("query-string");
/**
 * Takes a URL and query builder options and appends the query parameters
 * to the URL. It ignores query parameters which match the default query
 * parameters.
 *
 * @example
 * queryParamsBuilder({url: 'users/1', queryParams: { visible: true }, { defaultQueryParams: visible: false} }) === '/users/1?visible=true
 *
 * @param {String} options.url The url which get the query parameters appended.
 * @param {Object} options.queryParams The query params as an object.
 * @param {Object} options.defaultQueryParams The default query parameters.
 */
function queryParamsBuilder(options) {
    const { url, queryParams, defaultQueryParams } = options;
    const params = ignoreDefaultQueryParameters(queryParams, defaultQueryParams);
    const urlParams = (0, query_string_1.stringify)(params);
    if (urlParams) {
        return `${url}?${urlParams}`;
    }
    else {
        return url;
    }
}
exports.queryParamsBuilder = queryParamsBuilder;
function ignoreDefaultQueryParameters(queryParams, defaultQueryParams) {
    // Remove all values from the queryParams which match the defaultQueryParams
    const defaultRemovedQueryParams = {};
    Object.keys(queryParams).forEach((key) => {
        const defaultValue = defaultQueryParams[key];
        const actualValue = queryParams[key];
        // Only if it is not equal to the default value keep it.
        if (actualValue !== defaultValue) {
            defaultRemovedQueryParams[key] = actualValue;
        }
    });
    return defaultRemovedQueryParams;
}
